<template>
  <div v-if="isLoggedIn">
    <HeaderComponent />
    <div style="min-height: 100vh;" class="columns is-gapless">
      <!-- Page wrapper  -->
      <div class="column is-12-desktop is-12-tablet main-content"
        :style="`background-size:cover;background-repeat:no-repeat;background-color: #fff;`">
        <div style="padding-top: 5px;" class="section">
          <router-view />
        </div>
        <Footer></Footer>
      </div>
    </div>
  </div>
  <div v-else>
    <router-view />
  </div>
</template>

<script>
//Vuex
import { mapGetters } from 'vuex'
import HeaderComponent from '@/components/HeaderComponent'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    HeaderComponent,
    Footer,
  },
  data() {
    return {
      bg_image: require('@/assets/images/bg-pattern.svg'),
      bg_image_loggedin: require('@/assets/images/bg.png'),
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
  },
}
</script>
<style>
#app {
  font-family: 'Comfortaa', cursive;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>